import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type PartWeightDto = ClientInferRequest<typeof contract.parts.updateWeight>["body"];

type PartWeightResponse = ClientInferResponseBody<typeof contract.parts.updateWeight, 200>;

export const updatePartWeight = async (
  id: string,
  payload: PartWeightDto,
): Promise<PartWeightResponse> => {
  const response = await api.parts.updateWeight.mutation({
    params: { id },
    body: payload,
  });

  if (response.status !== 200) {
    throw new ApiError("Can't update part weight", response.status, response.body);
  }

  return response.body;
};
